
















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import BaseImage from "@/components/BaseImage";

Vue.component("BaseImage", BaseImage);
@Component({ name: "EmptyContent", components: { BaseImage } })
export default class EmptyContent extends Vue {
  @Prop()
  public readonly imgSrc!: string;

  @Prop()
  public readonly imgAlt!: string;

  @Prop({ type: String, default: "" })
  public readonly text!: string;
}
